import Highcharts from 'highcharts';
import { TimelineAxisSide, TimelineNumericSeries, TimelineSeriesCustomData } from '../../../shared';
import { mapNumericMainSeries } from './map-numeric-main-series';
import { mapNumericThresholdSeries } from './map-numeric-threshold-series';

type MapNumericSeriesOptions = {
    id: string;
    series: TimelineNumericSeries;
    side: TimelineAxisSide;
    themeColor: string;
    isFloat: boolean;
    unit?: string;
    pointEvents?: Highcharts.PointEventsOptionsObject;
};
export function mapNumericSeries({
    id,
    series,
    side,
    themeColor,
    isFloat,
    unit,
    pointEvents,
}: MapNumericSeriesOptions): ((Highcharts.SeriesLineOptions | Highcharts.SeriesScatterOptions) &
    TimelineSeriesCustomData)[] {
    // Map main series data
    const parentSeries = mapNumericMainSeries({
        id,
        series,
        side,
        themeColor,
        isFloat,
        unit,
        pointEvents,
    });

    // Try to map lower/upper threshold series. Null will be returned if they shouldn't be included.
    const upperThresholdSeries = mapNumericThresholdSeries({ parentSeries, series, key: 'Upper' });
    const lowerThresholdSeries = mapNumericThresholdSeries({ parentSeries, series, key: 'Lower' });

    return [parentSeries, upperThresholdSeries, lowerThresholdSeries].filter((x) => x != null);
}
